import { createContext, useContext } from 'react';
import type { UserProfile } from '@ooh/contracts';

export interface CurrentUser {
  user: UserProfile | null;
  permissions: readonly string[] | null;
}

export const CurrentUserContext = createContext<CurrentUser | null>(null);

export function useCurrentUser(): CurrentUser {
  const current = useContext(CurrentUserContext);
  if (current === null) throw new Error('useCurrentUser must be used inside <AppUiProvider>');
  return current;
}

// Permissions still loading (null) fail open by default; the server enforces the real rule.
export function useHasPermission(
  key: string,
  options: { loading?: 'open' | 'closed' } = {},
): boolean {
  const { permissions } = useCurrentUser();
  if (permissions === null) return options.loading !== 'closed';
  return permissions.includes(key);
}
